module.exports = __webpack_public_path__ + "img/kilian_landwehr_1.e5ce5f88.jpg";